import { FC, useState } from 'react'
import { Button } from 'react-admin'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import AiGenerateDialog from './AiGenerateDialog'
import { aiTokens } from './aiGeneratorTokens'

const AiGenerateButton: FC = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        label="workflow.ai.button"
        onClick={() => setOpen(true)}
        sx={{
          'color': aiTokens.accent,
          '& .MuiSvgIcon-root': { color: aiTokens.accent },
          '&:hover': { background: aiTokens.accentSoft },
        }}
      >
        <AutoAwesomeIcon />
      </Button>
      <AiGenerateDialog open={open} onClose={() => setOpen(false)} />
    </>
  )
}

export default AiGenerateButton
